export default __webpack_public_path__ + "static/media/Rectangle -6.a917c7f8.png";